<div class="card">

    <!-- ── Card Header ────────────────────────────────────────────────────── -->
    <div class="card-header">
        <h5 class="card-title mb-0">
            {{ TRANSLATE_KEY_MAP.FORM.TITLE() | translate }}
        </h5>
    </div>

    <!-- ── Card Body ──────────────────────────────────────────────────────── -->
    <div class="card-body">
        <form [formGroup]="facilityForm">

            <!-- ── Form Fields Grid ─────────────────────────────────────── -->
            <div class="row g-4">

                <!-- Facility Name -->
                <div class="col-12 col-md-6">
                    <app-input-field
                        name="name"
                        identifier="name"
                        formControlName="name"
                        [ignoreStatus]="'valid'"
                        [label]="TRANSLATE_KEY_MAP.FORM.FACILITY_NAME.LABEL() | translate"
                        [placeholder]="TRANSLATE_KEY_MAP.FORM.FACILITY_NAME.PLACEHOLDER() | translate"
                    />
                </div>

                <!-- Facility Type -->
                <div class="col-12 col-md-6">
                    <label class="form-label" for="facility_type_id">
                        {{ TRANSLATE_KEY_MAP.FORM.FACILITY_TYPE.LABEL() | translate }}
                    </label>
                    <ng-select
                        inputId="facility_type_id"
                        formControlName="facility_type_id"
                        bindValue="id"
                        bindLabel="name"
                        [clearable]="false"
                        [items]="facilityTypesLookup()"
                        [placeholder]="TRANSLATE_KEY_MAP.FORM.FACILITY_TYPE.PLACEHOLDER() | translate"
                    />
                </div>

                <ng-container formGroupName="address">

                    <!-- Building No -->
                    <div class="col-12 col-md-6 col-lg-4">
                        <app-input-field
                            type="number"
                            name="building_number"
                            identifier="building_number"
                            formControlName="building_number"
                            [ignoreStatus]="'valid'"
                            [label]="TRANSLATE_KEY_MAP.FORM.BUILDING_NO.LABEL() | translate"
                            [placeholder]="TRANSLATE_KEY_MAP.FORM.BUILDING_NO.PLACEHOLDER() | translate"
                        />
                    </div>

                    <!-- Street -->
                    <div class="col-12 col-md-6 col-lg-4">
                        <app-input-field
                            name="street_name"
                            identifier="street_name"
                            formControlName="street_name"
                            [ignoreStatus]="'valid'"
                            [label]="TRANSLATE_KEY_MAP.FORM.STREET.LABEL() | translate"
                            [placeholder]="TRANSLATE_KEY_MAP.FORM.STREET.PLACEHOLDER() | translate"
                        />
                    </div>

                    <!-- District -->
                    <div class="col-12 col-md-6 col-lg-4">
                        <app-input-field
                            name="district_name"
                            identifier="district_name"
                            formControlName="district_name"
                            [ignoreStatus]="'valid'"
                            [label]="TRANSLATE_KEY_MAP.FORM.DISTRICT.LABEL() | translate"
                            [placeholder]="TRANSLATE_KEY_MAP.FORM.DISTRICT.PLACEHOLDER() | translate"
                        />
                    </div>

                    <!-- City -->
                    <div class="col-12 col-md-6">
                        <app-input-field
                            name="city_name"
                            identifier="city_name"
                            formControlName="city_name"
                            [ignoreStatus]="'valid'"
                            [label]="TRANSLATE_KEY_MAP.FORM.CITY.LABEL() | translate"
                            [placeholder]="TRANSLATE_KEY_MAP.FORM.CITY.PLACEHOLDER() | translate"
                        />
                    </div>

                    <!-- Zip Code -->
                    <div class="col-12 col-md-6">
                        <app-input-field
                            type="number"
                            name="zip_code"
                            [valueAsNumber]="true"
                            identifier="zip_code"
                            formControlName="zip_code"
                            [ignoreStatus]="'valid'"
                            [label]="TRANSLATE_KEY_MAP.FORM.ZIP.LABEL() | translate"
                            [placeholder]="TRANSLATE_KEY_MAP.FORM.ZIP.PLACEHOLDER() | translate"
                        />
                    </div>

                    <!-- Additional No -->
                    <div class="col-12 col-md-6">
                        <app-input-field
                            type="number"
                            name="additional_number"
                            identifier="additional_number"
                            formControlName="additional_number"
                            [ignoreStatus]="'valid'"
                            [label]="TRANSLATE_KEY_MAP.FORM.ADDITIONAL_NO.LABEL() | translate"
                            [placeholder]="TRANSLATE_KEY_MAP.FORM.ADDITIONAL_NO.PLACEHOLDER() | translate"
                        />
                    </div>

                    <!-- Unit -->
                    <div class="col-12 col-md-6">
                        <app-input-field
                            type="number"
                            name="unit_number"
                            identifier="unit_number"
                            formControlName="unit_number"
                            [ignoreStatus]="'valid'"
                            [label]="TRANSLATE_KEY_MAP.FORM.UNIT.LABEL() | translate"
                            [placeholder]="TRANSLATE_KEY_MAP.FORM.UNIT.PLACEHOLDER() | translate"
                        />
                    </div>

                </ng-container>

                <!-- Latitude -->
                <div class="col-12 col-md-6 col-lg-3">
                    <app-input-field
                        name="latitude"
                        identifier="latitude"
                        formControlName="latitude"
                        [ignoreStatus]="'valid'"
                        [label]="TRANSLATE_KEY_MAP.FORM.LATITUDE.LABEL() | translate"
                        [placeholder]="TRANSLATE_KEY_MAP.FORM.LATITUDE.PLACEHOLDER() | translate"
                    />
                </div>

                <!-- Longitude -->
                <div class="col-12 col-md-6 col-lg-3">
                    <app-input-field
                        name="longitude"
                        identifier="longitude"
                        formControlName="longitude"
                        [ignoreStatus]="'valid'"
                        [label]="TRANSLATE_KEY_MAP.FORM.LONGITUDE.LABEL() | translate"
                        [placeholder]="TRANSLATE_KEY_MAP.FORM.LONGITUDE.PLACEHOLDER() | translate"
                    />
                </div>

                <!-- X Coordinate -->
                <div class="col-12 col-md-6 col-lg-3">
                    <app-input-field
                        name="x_coordinate"
                        identifier="x_coordinate"
                        formControlName="x_coordinate"
                        [ignoreStatus]="'valid'"
                        [label]="TRANSLATE_KEY_MAP.FORM.X_COORDINATE.LABEL() | translate"
                        [placeholder]="TRANSLATE_KEY_MAP.FORM.X_COORDINATE.PLACEHOLDER() | translate"
                    />
                </div>

                <!-- Y Coordinate -->
                <div class="col-12 col-md-6 col-lg-3">
                    <app-input-field
                        name="y_coordinate"
                        identifier="y_coordinate"
                        formControlName="y_coordinate"
                        [ignoreStatus]="'valid'"
                        [label]="TRANSLATE_KEY_MAP.FORM.Y_COORDINATE.LABEL() | translate"
                        [placeholder]="TRANSLATE_KEY_MAP.FORM.Y_COORDINATE.PLACEHOLDER() | translate"
                    />
                </div>

            </div>
            <!-- /Form Fields Grid -->

            <!-- ── Google Map ────────────────────────────────────────────── -->
            <div class="row mt-4">
                <div class="col-12">
                    <google-map
                        width="100%"
                        height="400px"
                        [zoom]="15"
                        [center]="mapCenter()"
                        [options]="mapOptions"
                        (mapClick)="onMapClick($event)"
                    >
                        <map-marker
                            [options]="{ draggable: true }"
                            [position]="markerPosition()"
                            (mapDragend)="onMarkerDragEnd($event)"
                        />
                    </google-map>
                </div>
            </div>
            <!-- /Google Map -->

            <!-- ── Action Buttons ────────────────────────────────────────── -->
            <div class="row mt-4">
                <div class="col-12 d-flex gap-2">
                    <button
                        appButton
                        variant="primary"
                        [disabled]="isLoading()"
                        (click)="submit()"
                    >
                        @if (isLoading()) {
                            <app-spin-kit-wave style="--sk-size: 20px;" bgColor="var(--bs-white)" />
                        }
                        @else {
                            {{ 'GENERAL.SAVE_CHANGES' | translate }}
                        }
                    </button>

                    <button
                        appButton
                        variant="secondary"
                        appearance="outline"
                        [disabled]="facilityForm.pristine || isLoading()"
                        (click)="cancel()"
                    >
                        {{ 'GENERAL.CANCEL' | translate }}
                    </button>
                </div>
            </div>
            <!-- /Action Buttons -->

        </form>
    </div>
    <!-- /Card Body -->

</div>